import { render, staticRenderFns } from "./PatientDocumentList.vue?vue&type=template&id=4eb49c86&"
import script from "./PatientDocumentList.vue?vue&type=script&lang=js&"
export * from "./PatientDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports